import { useEffect, useRef } from 'react'

export type LoginInput = {
  opened: boolean
  signupOnly: boolean
  oauthProviderDestUrl: string
  onClose: () => void
  onLogin: () => void
}

export function IkyuLogin({
  opened,
  signupOnly,
  oauthProviderDestUrl,
  onClose,
  onLogin,
}: LoginInput) {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    const a = ref.current
    if (a === null) {
      return
    }
    a.addEventListener('close', onClose)
    a.addEventListener('login', onLogin)
    return () => {
      a.removeEventListener('close', onClose)
      a.removeEventListener('login', onLogin)
    }
  }, [onClose, onLogin])

  return (
    /* @ts-ignore */
    <ikyu-login
      ref={ref}
      open={opened}
      signup-only={signupOnly}
      oauth-provider-dest-url={oauthProviderDestUrl}
    />
  )
}
